const handleChangeCurrency = (evt, data, setData) => {
  evt.preventDefault();
  const { name, value } = evt.target;
  const numberValue = value.replace(/,/g, '.');
  if (value === '' || value === ',' || !isNaN(numberValue)) {
    const newValue = value.replace(/\./g, ',');
    setData({
      ...data,
      [name]: newValue
    });
    evt.target.value = newValue;
  } else {
    evt.target.value = data[name].replace(/\./g, ',');
  }
};

export default handleChangeCurrency;
